import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-9f259ebc"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  id: "faq",
  class: "com-div clearfix loginContainer"
};
const _hoisted_2 = {
  class: "accS"
};

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "login-top"
}, "Account Settings", -1));

const _hoisted_4 = {
  class: ""
};

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "login-form-p"
}, "Username", -1));

const _hoisted_6 = {
  class: "lg-div"
};

const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont iconguanbi2fill hide"
}, null, -1));

const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "login-form-p"
}, "Email", -1));

const _hoisted_9 = {
  class: "lg-div"
};

const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont iconguanbi2fill hide"
}, null, -1));

const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "login-form-p"
}, "Enter your current password", -1));

const _hoisted_12 = {
  class: "lg-div"
};

const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont iconguanbi2fill hide"
}, null, -1));

const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "login-form-p"
}, "Enter your new password", -1));

const _hoisted_15 = {
  class: "lg-div"
};

const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont iconguanbi2fill hide"
}, null, -1));

const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "login-form-p"
}, "Re-enter your new password", -1));

const _hoisted_18 = {
  class: "lg-div"
};

const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont iconguanbi2fill hide"
}, null, -1));

const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "upSpanError upSpanSuccess",
  style: {
    "visibility": "hidden"
  }
}, [/*#__PURE__*/_createElementVNode("i", {
  class: "iconfont iconyuanxingxuanzhongfill"
}), /*#__PURE__*/_createTextVNode(), /*#__PURE__*/_createElementVNode("span", {
  id: "errorInfo"
})], -1));

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_hoisted_5, _createElementVNode("div", _hoisted_6, [_withDirectives(_createElementVNode("input", {
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.USERINFO.name = $event),
    type: "text",
    class: "lg-input se accSZhiDu",
    readonly: ""
  }, null, 512), [[_vModelText, _ctx.USERINFO.name]]), _hoisted_7]), _hoisted_8, _createElementVNode("div", _hoisted_9, [_withDirectives(_createElementVNode("input", {
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _ctx.USERINFO.email = $event),
    type: "text",
    class: "lg-input se accSZhiDu",
    readonly: ""
  }, null, 512), [[_vModelText, _ctx.USERINFO.email]]), _hoisted_10]), _hoisted_11, _createElementVNode("div", _hoisted_12, [_withDirectives(_createElementVNode("input", {
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _ctx.password = $event),
    type: "password",
    class: "lg-input",
    id: "oldPassword"
  }, null, 512), [[_vModelText, _ctx.password]]), _hoisted_13]), _hoisted_14, _createElementVNode("div", _hoisted_15, [_withDirectives(_createElementVNode("input", {
    "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _ctx.newPassword = $event),
    type: "password",
    class: "lg-input",
    id: "newPassword"
  }, null, 512), [[_vModelText, _ctx.newPassword]]), _hoisted_16]), _hoisted_17, _createElementVNode("div", _hoisted_18, [_withDirectives(_createElementVNode("input", {
    "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _ctx.confirmNewPassword = $event),
    type: "password",
    class: "lg-input",
    id: "confirmNewPassword"
  }, null, 512), [[_vModelText, _ctx.confirmNewPassword]]), _hoisted_19]), _createElementVNode("button", {
    class: "login-btn accSBtn",
    onClick: _cache[5] || (_cache[5] = //@ts-ignore
    (...args) => _ctx.updatePasswordFn && _ctx.updatePasswordFn(...args))
  }, "Submit"), _hoisted_20])])]);
}